// extracted by mini-css-extract-plugin
export default {"deleteIcon":"delete-user-confirm_deleteIcon__S45xQ"};